export default {
    edit_brand_create_title: 'Create Brand',
    edit_brand_edit_title: 'Edit Brand',
    edit_brand_brand_name: 'Title',
    edit_brand_brand_code: 'Code',
    edit_brand_brand_name_min_error: 'The brand title must contain minimum chars',
    edit_brand_brand_name_max_error: 'The brand title contain maximum chars',
    edit_brand_language: 'Language',
    edit_brand_time_zone: 'Time Zone',
    edit_brand_brand: 'Brand',
    edit_brand_crm: 'Salesforce Id',
    edit_brand_crm_min_error: 'The Salesforce Id must contain minimum chars',
    edit_brand_internal: 'Internal',
    edit_brand_yes: 'Yes',
    edit_brand_not: 'No',
    edit_brand_username: 'Username',
    edit_brand_username_error_min: 'The username must contain minimum chars',
    edit_brand_username_error_max: 'The username must contain maximum chars',
    edit_brand_email: 'Email',
    edit_brand_password: 'Password',
    edit_brand_role: 'Role',
    edit_brand_report_options: 'Report Options',
    edit_brand_site_options: 'Site Options',
    edit_brand_no_options: 'No Options',
    edit_brand_the_brand_has_been_edited: 'The brand has been edited',
    edit_brand_general: 'General',
    edit_brand_packages: 'Packages',
    edit_brand_automatic: 'Automatic',
    edit_brand_manual: 'Manually',
    edit_brand_click_to_copy_password: 'Click to copy password!',
    edit_brand_the_password_was_copied: 'The password was copied',
    edit_brand_package: 'Package',
    edit_brand_select: 'Select...',
    edit_brand_crm_max_error: 'The Salesforce Id must contain a maximum of chars',
    edit_brand_promiles_username: 'Promiles Username',
    edit_brand_promiles_email: 'Promiles Email',
    edit_brand_fuel_card_company_code: 'Fuel Card Company Code',
    edit_brand_additional_info: 'Additional Information',
    edit_brand_error_username: 'The username must contain only lowercase letters and numbers, spaces are not valid',
    edit_brand_verify_terms_conditions: 'Verify Terms and Conditions',
    edit_brand_verify_terms_conditions_message: "By activating this option (YES) requires the users the acceptance of terms and conditions during the authentication process. Once accepted the T&C the system doesn't prompt for this again",
    edit_brand_speed_limit_engine: 'Speed Limit Engine',
    edit_brand_rgeo_engine: 'Rgeo Engine',
    edit_brand_osm_with_fallback_google: "OSM with fallback to Google",
    edit_brand_osm_only: "OSM Only",
    edit_brand_web_service_integration: "WEX EFS",
    edit_brand_status: "Status",
    edit_brand_validate_credentials: "Validate Credentials",
    edit_brand_active: "Active",
    edit_brand_inactive: "Inactive",
    edit_brand_fuel_card_integrations: "Fuel Card Integrations",
    edit_brand_wex_credencials_success: "Credentials are valid",
    edit_brand_wex_credencials_error: "Credentials are invalid",
    edit_brand_wex_credencials_message: "Credentials must be validated",
    edit_brand_promiles: "Promiles",
    edit_brand_fuel_cards: "Fuel Cards",
    edit_brand_web_services_status: "Web Services Status",
    edit_brand_master_company: "Master Company",
    create_delaer_brand: "Brand",
    edit_brand_tos_url: "Terms of Service URL",
    edit_brand_domains: 'Domains',
    edit_brand_help_url: 'Help URL',
    edit_brand_address: 'Address',
    edit_brand_phone: 'Phone',
    edit_brand_login_background_image: 'Login Background Image',
    edit_brand_login_background_color: 'Login Background Color',
    edit_brand_login_company_logo: 'Login Company Logo',
    edit_brand_favicon: 'Favicon',
    edit_brand_home_page_url: 'Home Page URL',
    edit_brand_error_creating_brand: 'Error creating brand',
    edit_brand_the_brand_has_been_created: 'The brand has been created',
    edit_brand_in_app_logo: 'In-App Logo',
};